"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.descriptionProps = void 0;
/* istanbul ignore file @preserve */

const descriptionProps = exports.descriptionProps = {
  description: 'Novage+ Bio Activating Skincare is a revolution in anti-ageing: superior cosmeceutical performance; gentle to skin and nature, formulated for all skin types. While Novage ranges combine advanced technology with selected plan stems extracts, targeting specific signs of aging.'
};
